import { memo, ReactElement } from 'react';
import * as S from './DestinationTab.styles';
import URL from '@/common/app/utils/urlsUtils';
import { DestinationCard } from '@/common/ui/images/DestinationCard';
import { useMedia } from '@/common/service/hooks/useMedia';
import { DropdownArrow } from '@/shared/images/icons/DropdownArrow';
import { TStatesDestination } from '@/common/service/api/Destination/Destination';

export const DestinationTab = ({
    title,
    destinations,
    isViewMore,
    setIsViewMore,
    code,
}: {
    title: string;
    code: string;
    destinations: TStatesDestination[];
    isViewMore: boolean;
    setIsViewMore: (i: boolean) => void;
}): ReactElement => {
    const isMobileView = useMedia('(max-width: 991px)');

    return (
        <S.Row>
            <S.Title>{title}</S.Title>

            <S.Container>
                {!isViewMore
                    ? destinations
                          .slice(0, isMobileView ? 4 : 8)
                          .map(({ name, slug, total_activities, id }) => {
                              return (
                                  <S.Box key={name}>
                                      <DestinationCard
                                          title={name}
                                          experience={`${total_activities} Experiences`}
                                          imageSrc={`${URL.image}/destination/${id}/600x600/${slug}.jpg`}
                                          cardLink={`/destination/${code}/${slug}/`.toLowerCase()}
                                          key={name}
                                      />
                                  </S.Box>
                              );
                          })
                    : destinations.map(({ name, slug, total_activities, id }) => {
                          return (
                              <S.Box key={name}>
                                  <DestinationCard
                                      title={name}
                                      experience={`${total_activities} Experiences`}
                                      imageSrc={`${URL.image}/destination/${id}/600x600/${slug}.jpg`}
                                      cardLink={`/destination/${code}/${slug}/`.toLowerCase()}
                                      key={name}
                                  />
                              </S.Box>
                          );
                      })}
            </S.Container>
            {!isViewMore &&
                ((isMobileView && destinations.length > 4) ||
                    (!isMobileView && destinations.length > 8)) && (
                    <S.ButtonViewMore
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation();
                            setIsViewMore(true);
                        }}
                    >
                        View more
                        <DropdownArrow />
                    </S.ButtonViewMore>
                )}
        </S.Row>
    );
};

export default memo(DestinationTab);
